var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAreaIcon = function SvgAreaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 42 42"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "#fff",
    rx: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#39BC46",
    d: "M33.023 11.783a.72.72 0 0 0-.708-.032l-5.5 2.75-5.096-2.549v9.187a.728.728 0 1 1-1.456 0v-9.187L15.166 14.5l-5.499-2.75a.728.728 0 0 0-1.054.651v14.563c0 .276.156.528.403.651l5.422 2.712v-9.188a.728.728 0 1 1 1.456 0v9.188l5.097-2.549 5.097 2.549v-9.188a.728.728 0 1 1 1.456 0v9.188l5.422-2.712a.728.728 0 0 0 .403-.65V12.401a.728.728 0 0 0-.346-.62Z"
  })));
};
export default SvgAreaIcon;